import { OptimizationWorkloadPodContainer } from '@cast/types';

import { Typography, Box, Stack } from '@cast/design-system';

import { getPodRecommendedRequests } from '../../../_podStatusUtils';

type Props = {
  containers: OptimizationWorkloadPodContainer[];
};

export const RecommendationCell = ({ containers }: Props) => {
  const recommended = getPodRecommendedRequests(containers);

  if (!recommended) {
    return (
      <Box display="flex" alignItems="center" gap={12}>
        <Typography variant="P12R" sx={{ color: 'grey.400' }}>
          —
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={12}>
      <Stack>
        <Box display="flex" gap={4}>
          <Typography variant="P12R">
            {recommended.cpuCores.toFixed(3)}
          </Typography>
          <Typography
            variant="P12R"
            sx={{
              color: 'grey.400',
            }}
          >
            CPU
          </Typography>
        </Box>
        <Box display="flex" gap={4}>
          <Typography variant="P12R">
            {recommended.memoryGib.toFixed(3)}
          </Typography>
          <Typography
            variant="P12R"
            sx={{
              color: 'grey.400',
            }}
          >
            GiB
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};
